// Pseudo-random generator with starting seed
function mulberry32(a) {
    return function () {
        let t = a += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
export class Random {
    constructor(seed) {
        this.rand = mulberry32(seed);
    }
    randFloat(min = 0, max = 1) {
        if (max === undefined) {
            max = min;
            min = 0;
        }
        return this.rand() * (max - min) + min;
    }
    randInt(min, max) {
        let num = this.rand();
        // We don't want to overflow by 1, even with a 0.000001% chance
        num = num === 1 ? 0.999999 : num;
        return Math.floor(num * (max - min)) + min;
    }
}
